import React from "react";
import {
  Dispute,
  DoordashLogoLg,
  Downtime,
  EzCaterLogoLg,
  GoogleLogoLg,
  GrowthIcon,
  GrubhubLogoLg,
  OloLogoLg,
  Promotions,
  QuickBooksLogoLg,
  R365LogoLg,
  Rest365LogoLg,
  Reviews,
  SecureIcon,
  SettingIcon,
  SkipLogoLg,
  ToastLogoLg,
  UberEatsLogoLg,
  XeroLogoLg,
  NovadineLogoLg,
  AppfrontLogolg
} from "../../view/FinanceReco";
import { motion } from "framer-motion";
import { item } from "../homepage/Section1";
import { Link } from "react-router-dom";

const Section3 = () => {
  return (
    <div className="s3-fin-reco f-width m-auto">
      <div className="row">
        <div className="col-lg-6 col-sm-12">
          <p className="fs-md">Integrations that Power Financial Clarity</p>
          <p>
            <font className="fw-bold">
              Voosh connects directly with top delivery platforms, POS systems,
              and accounting tools
            </font>
            —like{" "}
            <font className="fw-bold">
              Uber Eats, DoorDash, Grubhub, Olo, Restaurant365,
              QuickBooks, and more
            </font>
            —to help you match sales, payouts, and bank deposits without the
            manual mess.
          </p>
          <div className="d-flex gap-3">
            <Link
              to={
                "https://meetings.hubspot.com/bilal-k-s/meeting-with-bilal&__hstc=181257784.c6a9d1b3be4a6fd2ed9c2295680beb42.1703009108941.1746007643280.1746038291275.298&__hssc=181257784.7.1746038291275&__hsfp=1658680018"
              }
            >
              <div className="btn btn-outline-dark rounded-pill fs-14px px-3 py-2">
                Learn more about integrations
              </div>
            </Link>
            <Link
              to={
                "https://meetings.hubspot.com/bilal-k-s/meeting-with-bilal&__hstc=181257784.c6a9d1b3be4a6fd2ed9c2295680beb42.1703009108941.1746007643280.1746038291275.298&__hssc=181257784.7.1746038291275&__hsfp=1658680018"
              }
            >
              <div className="btn btn-dark rounded-pill fs-14px px-3 py-2">
                Request other integrations
              </div>
            </Link>
          </div>
        </div>
        <div
          className="col-lg-6 col-sm-12 rounded slider-col"
          style={{ backgroundColor: "#f1f1f1b8" }}
        >
          <div className="slider-wrap">
            <div className="img-col">
              <div className="img-track">
                <img src={UberEatsLogoLg} alt="Uber eats logo" />
                <img src={DoordashLogoLg} alt="doordash logo" />
                <img src={GrubhubLogoLg} alt="grubhub logo" />
                <img src={Rest365LogoLg} alt="yelp logo" />
                <img src={SkipLogoLg} alt="skip logo" />

                <img src={UberEatsLogoLg} alt="Uber eats logo" />
                <img src={DoordashLogoLg} alt="doordash logo" />
                <img src={GrubhubLogoLg} alt="grubhub logo" />
                <img src={Rest365LogoLg} alt="yelp logo" />
                <img src={SkipLogoLg} alt="skip logo" />
              </div>
            </div>
          </div>
          <div className="slider-wrap">
            <div className="img-col">
              <div className="img-track img-track2">
                <img src={AppfrontLogolg} alt="square logo" />
                <img src={ToastLogoLg} alt="toast logo" />
                <img src={R365LogoLg} alt="r 365 logo" />
                <img src={NovadineLogoLg} alt="lunchbox logo" />
                <img src={OloLogoLg} alt="olo logo" />

                <img src={AppfrontLogolg} alt="square logo" />
                <img src={ToastLogoLg} alt="toast logo" />
                <img src={R365LogoLg} alt="r 365 logo" />
                <img src={NovadineLogoLg} alt="lunchbox logo" />
                <img src={OloLogoLg} alt="olo logo" />
              </div>
            </div>
          </div>
          <div className="slider-wrap">
            <div className="img-col">
              <div className="img-track">
                <img src={QuickBooksLogoLg} alt="quick books logo" />
                <img src={EzCaterLogoLg} alt="ez cater logo" />
                <img src={Rest365LogoLg} alt="r 365 logo" />
                <img src={XeroLogoLg} alt="post mates logo" />
                <img src={GoogleLogoLg} alt="google logo" />

                <img src={QuickBooksLogoLg} alt="quick books logo" />
                <img src={EzCaterLogoLg} alt="ez cater logo" />
                <img src={Rest365LogoLg} alt="r 365 logo" />
                <img src={XeroLogoLg} alt="post mates logo" />
                <img src={GoogleLogoLg} alt="google logo" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row mt-100px w-f-t-c-v">
        <p className="fs-md">Why Finance Teams Choose Voosh</p>
        <motion.div
          variants={item}
          whileInView="visible"
          initial="hidden"
          transition={{ duration: 1 }}
          className="col-lg-4 col-sm-12"
        >
          <img src={SecureIcon} alt="Secure Reliable Automated" />
          <p>
            <strong>Secure, Reliable, Automated:</strong>
            <br />
            Voosh encrypts all your financial data and flags issues before they
            cost you.
          </p>
        </motion.div>
        <motion.div
          variants={item}
          whileInView="visible"
          initial="hidden"
          transition={{ duration: 1.5 }}
          className="col-lg-4 col-sm-12"
        >
          <img src={SettingIcon} alt="Fits Into Your Stack" />
          <p>
            <strong>Fits Into Your Stack:</strong>
            <br />
            Effortlessly integrates with POS, accounting, and marketplace
            systems.
          </p>
        </motion.div>
        <motion.div
          variants={item}
          whileInView="visible"
          initial="hidden"
          transition={{ duration: 2 }}
          className="col-lg-4 col-sm-12"
        >
          <img src={GrowthIcon} alt="Built to Scale" />
          <p>
            <strong>Built to Scale:</strong>
            <br />
            From one location to hundreds, Voosh scales with your business
            needs.
          </p>
        </motion.div>
      </div>
      <div className="row bg-dark rounded-4 mt-100px fin-s3-cta-btn shadow">
        <div className="col-lg-7 col-sm-12 text-white">
          <p className="fs-md">Bring accuracy to every payout!</p>
          <p>
            Schedule your personalized demo to see how Voosh's Finance
            Reconciliation Dashboard can quickly identify discrepancies, track
            your revenue, and simplify your accounting processes.
          </p>
        </div>
        <div className="col-lg-5 col-md-12 text-end align-self-center">
          <Link
            to={
              "https://meetings.hubspot.com/bilal-k-s/meeting-with-bilal&__hstc=181257784.c6a9d1b3be4a6fd2ed9c2295680beb42.1703009108941.1746007643280.1746038291275.298&__hssc=181257784.7.1746038291275&__hsfp=1658680018"
            }
          >
            <div className="btn btn-light rounded-pill">Book Demo Call</div>
          </Link>
        </div>
      </div>
      <div className="fin-s3-features mt-100px">
        <p className="fs-md">Explore other useful features</p>
        <div className="slider-wrap">
          <div className="img-col">
            <div className="img-track">
              <img src={Promotions} alt="Voosh promotion manager" />
              <img src={Downtime} alt="Voosh downtime controller" />
              <img src={Reviews} alt="Voosh Reviews and Rating" />
              <img src={Dispute} alt="Voosh dispute manager" />

              <img src={Promotions} alt="Voosh promotion manager" />
              <img src={Downtime} alt="Voosh downtime controller" />
              <img src={Reviews} alt="Voosh Reviews and Rating" />
              <img src={Dispute} alt="Voosh dispute manager" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section3;
